import React, { FC, useState } from 'react';

import CTA from 'Src/components/buttons/CTA';
import { Flex } from 'Src/components/layout/Flex';
import { useAuthRequest } from 'Src/feature/auth-request/useAuthRequest';
import { useCurrentAuthRequest } from 'Src/feature/auth-request/useCurrentAuthRequest';
import { FormField } from 'Src/feature/form/FormField';
import AuthorizationRequest from 'Src/models/AuthorizationRequest';
import { EntitlementId, entitlementIds } from 'Src/models/Entitlement';

const entitlementOptions = entitlementIds.map((key) => ({ label: key, value: key as EntitlementId }));

const AuthRequestTool: FC<React.PropsWithChildren> = () => {
  const { mutateAsync: createAuth } = useAuthRequest.mutate.create();
  const { setCurrentRequest } = useCurrentAuthRequest();

  const initialValues = {
    entitlementId: 'pos.checks.payment.accept.execute',
    checkId: 0,
  };

  const [formValues, setFormValues] = useState(initialValues);

  const createAuthRequest = async (formVals: typeof formValues) => {
    const resp = await createAuth({ entitlementId: formVals.entitlementId, checkId: parseInt(formVals.checkId.toString()) });
    setCurrentRequest(resp as AuthorizationRequest);
  };

  return (
    <Flex horizontal fullWidth alignItems="center" padding="sm">
      <FormField
        type="select"
        name="entitlementId"
        value={formValues.entitlementId}
        onChange={(_evt, values) => {
          setFormValues({
            ...formValues,
            entitlementId: values[0] as EntitlementId,
          });
        }}
        fullWidth
        options={entitlementOptions}
        label="Create Authorization Request"
        size="sm"
      />
      <FormField
        name="checkId"
        label="Check ID"
        type="number"
        value={formValues.checkId}
        fullWidth
        onChange={(evt) => {
          const { name, value } = evt.target;
          setFormValues({
            ...formValues,
            [name]: value,
          });
        }}
        size="sm"
      />
      <CTA
        onClick={() => createAuthRequest(formValues)}
        label="Create Request"
      />
    </Flex>
  );
};

export default AuthRequestTool;
